export default __webpack_public_path__ + "static/media/type_2.a87554ad.svg";